// Business dates are Asia/Riyadh calendar dates. Offsets are calendar days,
// not a UTC clock shift.

export function businessDate(instant: Date, offsetDays = 0): string {
  const formatted = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Riyadh',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(instant);
  if (offsetDays === 0) return formatted;
  const [year, month, day] = formatted.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(year, month - 1, day + offsetDays)).toISOString().slice(0, 10);
}
